import {
  CalculateParkingExtensionPriceResultDTO,
  CalculateExtendFastCheckinParkingDTO,
  ExtendFastCheckinParkingDTO,
  FastCheckinClient,
  FastCheckinParkingSessionInfoDTO,
  FastCheckinSessionDTO,
  ParkingQuotaInfoDTO,
  SavedReportFileDTO,
  StartFastCheckinParkingExtensionPaymentProcessDTO,
  StartFastCheckinParkingExtensionPaymentProcessResponseDTO,
  ValidateFastCheckinSessionDTO
} from './../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { map, Observable, tap, throwError } from 'rxjs';
import { AuthService } from 'src/app/base/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FastCheckinSessionService {

  public sessionInfo: FastCheckinParkingSessionInfoDTO | null = null;

  constructor(private fastCheckinClient: FastCheckinClient,
    private authService: AuthService
  ) { }

  public loadFastCheckinParkingSessionInfo(sessionIdent: string): Observable<FastCheckinParkingSessionInfoDTO | null> {
    return this.fastCheckinClient.getFastCheckinParkingSessionInfo(new FastCheckinSessionDTO({ sessionIdent }))
    .pipe(
      tap(info => this.sessionInfo = info)
    );
  }

  public checkOutFromFastCheckinSession(sessionIdent: string): Observable<FastCheckinParkingSessionInfoDTO> {
    return this.fastCheckinClient.checkoutFastCheckinParking(new FastCheckinSessionDTO({ sessionIdent }), this.authService.getAnonymousUserLanguage());
  }

  public downloadReceipt(sessionIdent: string | null): Observable<SavedReportFileDTO> {
    if (!sessionIdent) {
      return throwError(() => new Error('SessionIdentMissing'));
    }
    return this.fastCheckinClient.exportFastCheckinParkingSessionReport(new FastCheckinSessionDTO({ sessionIdent }), this.authService.getAnonymousUserLanguage());
  }

  public validateParkingCard(sessionIdent: string, parkingCardIdent: string): Observable<FastCheckinParkingSessionInfoDTO | null> {
    return this.fastCheckinClient.validateFastCheckinParkingSession(new ValidateFastCheckinSessionDTO({ sessionIdent, parkingCardIdent }), this.authService.getAnonymousUserLanguage());
  }

  public getForeignParkingFastCheckinQuotaInfo(zoneId: number, selectedSubscriptionId: number, controlPlateNumber: string): Observable<ParkingQuotaInfoDTO> {
    return this.fastCheckinClient.getForeignParkingFastCheckinQuotaInfo(zoneId, selectedSubscriptionId, controlPlateNumber);
  }

  public calculateExtensionPrice(sessionIdent: string, extensionInMinutes: number): Observable<CalculateParkingExtensionPriceResultDTO> {
    const calculateDto = new CalculateExtendFastCheckinParkingDTO({
      sessionIdent,
      extensionInMinutes
    });

    return this.fastCheckinClient.calculateParkingExtensionPriceFastCheckin(calculateDto);
  }

  public extendSessionNoPayment(sessionIdent: string, extensionInMinutes: number, cachedCalculationResult: CalculateParkingExtensionPriceResultDTO): Observable<void> {
    if (!cachedCalculationResult) {
      return throwError(() => new Error('ExtensionPaymentDataMissing'));
    }

    const extendDto = new ExtendFastCheckinParkingDTO({
      sessionIdent,
      extensionInMinutes,
      parkingPriceDetails: cachedCalculationResult.parkingPriceDetails,
      fallbackParkingPriceDetails: cachedCalculationResult.fallbackPriceDetails
    });

    return this.fastCheckinClient.extendFastCheckinParkingSessionNoPayment(extendDto, this.authService.getAnonymousUserLanguage())
      .pipe(
        map((extendResult) => {
          if (
            extendResult?.offense !== undefined &&
            extendResult.offense !== 0
          ) {
            throw new Error("SessionExtensionFailed");
          }

          return undefined;
        }),
      );
  }

  public startExtensionPaymentProcess(sessionIdent: string,
    extensionInMinutes: number,
    cachedCalculationResult: CalculateParkingExtensionPriceResultDTO): Observable<StartFastCheckinParkingExtensionPaymentProcessResponseDTO> {
    if (!cachedCalculationResult) {
      return throwError(() => new Error('ExtensionPaymentDataMissing'));
    }

    const startPaymentDto = new StartFastCheckinParkingExtensionPaymentProcessDTO({
      sessionIdent,
      extensionInMinutes,
      parkingPriceDetails: cachedCalculationResult.parkingPriceDetails,
      fallbackParkingPriceDetails: cachedCalculationResult.fallbackPriceDetails
    });

    return this.fastCheckinClient.startParkingExtensionPaymentProcessFastCheckin(startPaymentDto);
  }

}
